import { Phone, Mail, Instagram, ExternalLink } from "lucide-react";
import { logos, navLinks, contactInfo, services, dataStore365 } from "../../data/mock";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="relative bg-[#030308] border-t border-white/[0.04]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1 space-y-5">
            <img
              src={logos.horizontal}
              alt="InnovArs Microsistemas"
              className="h-8 w-auto"
            />
            <p className="text-sm text-white/25 leading-relaxed max-w-xs">
              Soluciones tecnológicas integrales para comercios e industrias.
              Innovación y calidad en cada proyecto.
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-5">
            <h4 className="text-[11px] font-semibold text-white/40 uppercase tracking-[0.15em]">
              Navegación
            </h4>
            <div className="space-y-3">
              {navLinks.map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollToSection(link.href)}
                  className="block text-sm text-white/25 hover:text-white/60 transition-colors duration-300"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="space-y-5">
            <h4 className="text-[11px] font-semibold text-white/40 uppercase tracking-[0.15em]">
              Servicios
            </h4>
            <div className="space-y-3">
              {services.map((s) => (
                <p key={s.id} className="text-sm text-white/25">
                  {s.title}
                </p>
              ))}
              <a
                href={dataStore365.loginUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-1.5 text-sm text-cyan-400/40 hover:text-cyan-400/70 transition-colors duration-300"
              >
                DataStore365
                <ExternalLink size={11} />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-5">
            <h4 className="text-[11px] font-semibold text-white/40 uppercase tracking-[0.15em]">
              Contacto
            </h4>
            <div className="space-y-3">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-center gap-2.5 text-sm text-white/25 hover:text-white/60 transition-colors duration-300"
              >
                <Phone size={13} className="flex-shrink-0" />
                {contactInfo.phone}
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center gap-2.5 text-sm text-white/25 hover:text-white/60 transition-colors duration-300"
              >
                <Mail size={13} className="flex-shrink-0" />
                {contactInfo.email}
              </a>
              <a
                href={contactInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2.5 text-sm text-white/25 hover:text-white/60 transition-colors duration-300"
              >
                <Instagram size={13} className="flex-shrink-0" />
                {contactInfo.instagram}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-white/[0.04] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/15">
            © {currentYear} InnovArs Microsistemas. Todos los derechos
            reservados.
          </p>
          <p className="text-xs text-white/15">
            Tecnología inteligente, soluciones reales
          </p>
        </div>
      </div>
    </footer>
  );
};
